import styles from "./SertificatesSummary.module.css";
import { Table } from "rsuite";
import { useNavigate } from "react-router-dom";
const { Column, HeaderCell, Cell } = Table;

let ExpireDateCell = ({ rowData, dataKey, ...props }) => {
  const navigate = useNavigate();
  let styleExpDate = styles.expired_total;
  if (dataKey == "totalExpired") {
    styleExpDate = rowData[dataKey] > 0 ? styles.exp_color : styleExpDate;
  }

  if (dataKey == "expireIn30days") {
    styleExpDate = rowData[dataKey] > 0 ? styles.exp_30_color : styleExpDate;
  }

  if (["expireIn90days", "endorsementIn90days"].includes(dataKey)) {
    styleExpDate = rowData[dataKey] > 0 ? styles.blue_color : styleExpDate;
  }

  const handleClick = (e) => {
    if (dataKey === "totalExpired" && rowData[dataKey] > 0) {
      e.stopPropagation();
      navigate("/certificates", {
        state: {
          filter: {
            locationId: rowData.locationId || rowData.vesselId,
            expireRange: "Expired",
          },
        },
      });
    }
  };

  const cellStyle =
    dataKey === "totalExpired" && rowData[dataKey] > 0
      ? { cursor: "pointer" }
      : {};

  return (
    <>
      <Cell {...props}>
        <span className={styleExpDate} style={cellStyle} onClick={handleClick}>
          {rowData[dataKey]}
        </span>
      </Cell>
    </>
  );
};

function SertificatesSummary({ title, expiredCertificates }) {
  return (
    <>
      <div className={styles.table_container}>
        <div className={styles.table_title}>{title}</div>

        <Table loading={false} autoHeight data={expiredCertificates}>
          <Column width={200} align="left" fixed>
            <HeaderCell>Vessel</HeaderCell>
            <Cell dataKey="vesselName" />
          </Column>

          <Column width={180}>
            <HeaderCell>Expired certificates</HeaderCell>
            <ExpireDateCell dataKey="totalExpired" />
          </Column>

          <Column width={180}>
            <HeaderCell>Expire in 30 days</HeaderCell>
            <ExpireDateCell dataKey="expireIn30days" />
          </Column>

          <Column width={180}>
            <HeaderCell>Expire in 90 days</HeaderCell>
            <ExpireDateCell dataKey="expireIn90days" />
          </Column>

          <Column width={180}>
            <HeaderCell>End. in 90 days</HeaderCell>
            <ExpireDateCell dataKey="endorsementIn90days" />
          </Column>
        </Table>
      </div>
    </>
  );
}

export default SertificatesSummary;
